module.exports = __webpack_public_path__ + "static/media/Control_vipra.6e16fd21.png";